<template>
	<div class="flex h-full items-center justify-center p-8 text-sm text-dimmed">
		<slot />
	</div>
</template>
